import { useCallback } from 'react'
import { useZocksQuota } from '../../../../components/ScopedBlock/hooks'
import { getIntegrationSettingsSchema, IntegrationSettings } from './schema'
import { get, useFormContext } from 'react-hook-form'

export const useGetSchemaErrors = () => {
  const { watch } = useFormContext<IntegrationSettings>()
  const values = watch()
  const { getQuotaValue } = useZocksQuota()
  const additionalObjectsLimit = getQuotaValue('integration.additionalObjMax.value')

  const getIntegrationSettingsSchemaRawErrors = useCallback(() => {
    const result = getIntegrationSettingsSchema(additionalObjectsLimit as number).safeParse(values)
    if (!result.success) {
      return result.error.format()
    }
  }, [values, additionalObjectsLimit])

  const getErrorOnPath = (fieldsPath: string, key?: string | number): string | undefined => {
    const rawErrors = getIntegrationSettingsSchemaRawErrors()
    const fieldError = key ? get(rawErrors, `${fieldsPath}.${key}._errors`)?.[0] : get(rawErrors, `${fieldsPath}._errors`)?.[0]

    return fieldError
  }

  return {
    getIntegrationSettingsSchemaRawErrors,
    getErrorOnPath,
  }
}
